/**
 * Overlay box ids are `{block_id}-{spreadSlot}` where `spreadSlot` is `0` or `1` for
 * the left/right pane in a two-page spread. `block_id` is document-OCR `id`, i.e.
 * `ocr_blocks.id` (may contain hyphens), so we split on the **last** hyphen only.
 */
export function parseViewerBoxId(boxId: string): {
  blockId: string
  spreadPageIndex: number
} | null {
  const lastDash = boxId.lastIndexOf('-')
  if (lastDash === -1) return null
  const tail = boxId.slice(lastDash + 1)
  const spreadPageIndex = parseInt(tail, 10)
  if (Number.isNaN(spreadPageIndex)) return null
  const blockId = boxId.slice(0, lastDash)
  if (!blockId) return null
  return { blockId, spreadPageIndex }
}

/** Stable key for matching OCR results to knowledge docs (instance_id + page). */
export function ocrResultMatchKey(
  id: string | number,
  pageNumber: number
): string {
  return `${String(id)}-${pageNumber}`
}

export function knowledgeDocInstanceMatchesOcrId(
  kdInstanceId: string | number,
  ocrId: string | number
): boolean {
  return String(kdInstanceId) === String(ocrId)
}
